import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "frame", "trigger"]
  static values = { clearOnClose: { type: Boolean, default: true }, preloaded: Boolean }

  toggle(event) {
    const opening = this.panelTarget.classList.contains("hidden")
    const repeatedTrigger = this.currentTrigger === event.currentTarget

    if (this.preloadedValue || (!opening && repeatedTrigger)) event.preventDefault()

    if (!opening && repeatedTrigger) {
      this.close()
    } else {
      this.currentTrigger = event.currentTarget
      this.open()
    }
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    this.triggerTargets.forEach((trigger) => trigger.setAttribute("aria-expanded", String(trigger === this.currentTrigger)))
  }

  close(event) {
    event?.preventDefault()
    this.panelTarget.classList.add("hidden")
    this.triggerTargets.forEach((trigger) => trigger.setAttribute("aria-expanded", "false"))
    this.currentTrigger = null
    if (this.clearOnCloseValue) {
      this.frameTarget.innerHTML = ""
      this.frameTarget.removeAttribute("src")
      this.frameTarget.removeAttribute("complete")
    }
  }
}
